export const PAGE_SIZE_OPTIONS = [25, 50, 75, 100] as const;

export const DEFAULT_PAGE_SIZE = PAGE_SIZE_OPTIONS[0];
